import React, { useEffect, useState } from "react";
import {
  Container,
  Table,
  Button,
  Spinner,
  Card,
  CardBody,
  CardTitle,
} from "reactstrap";
import axios from "axios";
import useApiError from "../../Routes/useApiError";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

export default function Payments() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit] = useState(10); // Items per page
  const [totalPages, setTotalPages] = useState(1);

  const handleApiError = useApiError();
  const userData = JSON.parse(sessionStorage.getItem("userData")) || {};

  useEffect(() => {
    fetchInvoices();
  }, [page]); // re-fetch when page changes

  const fetchInvoices = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_COLLEGE_ERP_API}lib-invoices`,
        {
          params: {
            branch: userData.branch,
            page,
            limit,
          },
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );

      // Expect backend to return: { data: [...], totalPages: number }
      setInvoices(response.data?.data || []);
      setTotalPages(response.data?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching invoices:", error);
      handleApiError(error?.response?.data || error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const renderPagination = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <Button
          key={i}
          color={i === page ? "primary" : "light"}
          onClick={() => handlePageChange(i)}
          className="mx-1"
        >
          {i}
        </Button>
      );
    }

    return (
      <div className="d-flex justify-content-center mt-3">
        <Button
          color="light"
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 1}
          className="mx-1"
        >
          <FaArrowLeft />
        </Button>
        {pages}
        <Button
          color="light"
          onClick={() => handlePageChange(page + 1)}
          disabled={page === totalPages}
          className="mx-1"
        >
          <FaArrowRight />
        </Button>
      </div>
    );
  };

  return (
    <Container className="mt-4">
      <Card>
        <CardBody>
          <CardTitle tag="h4">Payments</CardTitle>

          {loading ? (
            <div className="text-center p-4">
              <Spinner color="primary" />
            </div>
          ) : invoices.length === 0 ? (
            <p className="text-muted">No invoices found.</p>
          ) : (
            <>
              <Table bordered hover responsive>
                <thead className="table-light">
                  <tr>
                    <th>Invoice ID</th>
                    <th>Member ID</th>
                    <th>Member Name</th>
                    <th>Amount (₹)</th>
                    <th>Payment Mode</th>
                    <th>Activation Date</th>
                    <th>Expiry Date</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices.map((inv) => (
                    <tr key={inv._id}>
                      <td>{inv.invoiceId}</td>
                      <td>{inv.Member_ID}</td>
                      <td>{inv.Member_Name}</td>
                      <td>{inv.Invoice_Amount}</td>
                      <td>{inv.Payment_Mode}</td>
                      <td>
                        {inv.Activation_Date
                          ? new Date(inv.Activation_Date).toLocaleDateString()
                          : ""}
                      </td>
                      <td>
                        {inv.Expiry_Date
                          ? new Date(inv.Expiry_Date).toLocaleDateString()
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {renderPagination()}
            </>
          )}

          <div className="mt-3 d-flex justify-content-end">
            <Button color="secondary" onClick={() => fetchInvoices()}>
              Refresh
            </Button>
          </div>
        </CardBody>
      </Card>
    </Container>
  );
}
